export const TestCaseTypeOptions = [
  'Smoke',
  'Regression',
  'Functional',
  'UAT',
  'Production check',
];

export const TestCasePriorityOptions = ['Low', 'Medium', 'High', 'Critical'];

export const TestCaseStatusOptions = ['Low', 'Medium', 'High', 'Critical'];

export const CsvImportDelimiterOptions = [
  { key: ',', label: 'Comma (,)' },
  { key: ';', label: 'Semicolon (;)' },
  { key: '|', label: 'Pipe (|)' },
  { key: '\t', label: 'Tab (\\t)' }
];

export const gainssTestCaseFields = [
  { key: 'summary', label: 'Description (max 255 characters)' },
  { key: 'objective', label: 'Objective (max 500 characters)' },
  { key: 'preCondition', label: 'Pre-condition (max 500 characters)' },
  { key: 'module', label: 'Module' },
  { key: 'owner', label: 'Owner' },
  { key: 'labels', label: 'Labels (Comma-Separated)' },
  { key: 'country', label: 'Country (Comma-Separated)' },
  {
    key: 'isAutomationNeeded',
    label: 'Candidate for Automation',
  },
  {
    key: 'automationStatus',
    label: 'Automation Status',
  },
  {
    key: 'isAutomated',
    label: 'Is Automated',
  },
  {
    key: 'automationMethod',
    label: 'Automation Method (max 100 characters)',
  },
  {
    key: 'automatedBy',
    label: 'Automated By',
  },
  {key: 'automationCountry', label: 'Automated For Country (Comma-Separated)'},
  { key: 'step', label: 'Step Description (max 2000 characters)' },
  { key: 'testData', label: 'Test Step Data (max 2000 characters)' },
  {
    key: 'expectedResult',
    label: 'Test Step Expected Result (max 2000 characters)',
  },
  { key: 'uri', label: 'Test Step URI (max 250 characters)' },
  {
    key: 'jiraIssues',
    label: 'Linked Issues (Comma-Separated)',
  }
];

export const purposeOptions = [
  'Sanity',
  'Regression',
  'Sprint Validation',
  'UAT',
  'Production',
];

export const testCyleTypeOptions = [
  'Manual',
  'Automation',
]

export const techLayers = [
  'None',
  'Database',
  'Contract',
  'API/Integration',
  'Web Front-end',
  'Mobile Front-end',
];

export const automationStatuses = ['Todo', 'In Progress', 'Blocked', 'Done'];


export const techLayerFilters = [
  'All',
  'Database',
  'Contract',
  'API/Integration',
  'Web Front-end',
  'Mobile Front-end',
];
